import { useContext, useState } from "react"
import { Box, Grid2 as Grid, IconButton, ThemeProvider} from "@mui/material"
import { getMuiTheme } from "../utilities/muiTheme"
import { rootContext } from "../contexts/rootContext"
import { useNavigate } from 'react-router'
import { Guard } from "./Guard"

type Props = {
  children: any,
  disableHeader?: boolean
  disableEdges?: boolean
}

let activeTimeout = -1

function PageTemplate({children, disableHeader=false, disableEdges=false}: Props) {
  const context = useContext(rootContext)
  const navigate = useNavigate()

  const muiTheme = getMuiTheme(context.theme)
  const hideEdges = context.isScreenTooSmall || disableEdges

  const [clickCount, setClickCount] = useState(0)
  const [showGuard, setShowGuard] = useState(false)

  // @ts-ignore
  document.body.style = `
    background-color: ${context.theme.sky};
    cursor: url(${context.theme.cursor.default}), default;
    transition: ${context.theme.transitions.backgroundColor};
    font-family: ${context.theme.font};
    font-size: 125%;
  `

  const handleSwitchMode = () => {
    if (clickCount === 4) {
      setShowGuard(true)
      setTimeout(()=>setShowGuard(false),5000)
    } else if (context.themeMode === "dark")
      context.setThemeMode("light")
    else
      context.setThemeMode("dark")

    setClickCount(prev => prev + 1)

    clearTimeout(activeTimeout)
    // @ts-ignore
    activeTimeout = setTimeout(() => {
      setClickCount(0)
    }, 1000)
  }

  return (<ThemeProvider theme={muiTheme}><Box 
    sx={{ 
      position: "relative",
      backgroundColor: context.theme.background,
      transition: `${context.theme.transitions.backgroundColor}, 
        ${context.theme.transitions.color}`,
      width: hideEdges ? "100vw" : "80vw",
      left: hideEdges ? "0" : "10vw",
      color: context.theme.text.primary,
      height: "100dvh",
      "&::after": hideEdges ? {} : {
        filter: "blur(25px)",
        transform: "translate3d(0, 0, 0)",
        width: "105%",
        left: "-2.5%"
      },
      "&::after, &::before": hideEdges ? {} : {
        content: '""',
        position: 'absolute',
        top: "0",
        left: "0",
        bottom: "0",
        right: "0",
        background: `linear-gradient(
          45deg,
          #fbc64c,
          #FFB200,
          #EB5B00,
          #E4003A,
          #EB5B00,
          #FFB200,
          #fbc64c
        )`,
        backgroundSize: "400%",
        zIndex: "-1",
        animation: "glow 20s linear infinite",
        width: "100%"
      }
    }}
  >
    <Grid 
      container 
      spacing={0} 
      direction="column" 
      sx={{ height: "100dvh" }}
    >
      { !disableHeader && <Grid 
        container 
        sx={{ paddingTop: "5px", paddingRight: "25px", paddingLeft: "25px" }} 
        spacing={0} size={12} 
        justifyContent="space-between"
      >
          <IconButton
            onClick={()=>{navigate("/")}} 
            sx={{
              cursor: `url(${context.theme.cursor.pointer}), pointer`,
              "&:hover": { 
                backgroundColor: context.theme.misc.buttonHover
              }
            }}
            aria-label="navigate home"
          >
              <img 
                src={context.theme.icons.cicada}
                height="32px"
                width="32px"
                alt="cicada logo"
              />
          </IconButton>
          <IconButton
            disabled={showGuard}
            onClick={handleSwitchMode} 
            sx={{
              cursor: `url(${context.theme.cursor.pointer}), pointer`,
              color: context.theme.text.primary,
              height: "48px",
              width: "48px",
              "&:hover": { 
                backgroundColor: context.theme.misc.buttonHover
              }
            }}
            aria-label={context.themeMode === "dark" ? "enable light mode" : "enable dark mode"}
          >
              {typeof context.theme.icons.switchMode === "string" ?
                <img src={context.theme.icons.switchMode} width="25px" /> 
                : 
                <context.theme.icons.switchMode />
              }
          </IconButton>
      </Grid>}
      {children}
    </Grid>
  </Box>
  {showGuard &&
    <Guard />
  }
  </ThemeProvider>)
}

export default PageTemplate
